import { render, staticRenderFns } from "./input-radio-boolean-reactive.vue?vue&type=template&id=6d04cbd4"
import script from "./input-radio-boolean-reactive.vue?vue&type=script&lang=js"
export * from "./input-radio-boolean-reactive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports